export enum audiencesActions {
    UPDATE_AUDIENCES_TABLE_STATE = '[AUDIENCES] UPDATE_AUDIENCES_TABLE_STATE',
    SET_CURRENT_TAB = '[AUDIENCES] SET_CURRENT_TAB',
    SET_SEARCH_TERM = '[AUDIENCES] SET_SEARCH_TERM',
    RESET = '[AUDIENCES] RESET',
    SET_INTEGRATIONS_DATA_PROPERTY = '[AUDIENCES] SET_INTEGRATIONS_DATA_PROPERTY'
}
